import { PartyDto } from 'data';

export function localPartyIdsToDtos(
  partyIds: string[] = [],
): { party: string; identifier: string; isLocal: true; displayName: string }[] {
  return partyIds.map((id) => ({
    party: id,
    identifier: id,
    isLocal: true as const,
    displayName: '',
  }));
}

export const partySelectAdapter = (partyDto: PartyDto[], partyFieldName: string) => {
  return (
    partyDto?.map((el) => {
      return {
        value: el[partyFieldName],
        label: el.displayName
          ? `${el.displayName} (${el[partyFieldName]?.slice(0, 29)}...)`
          : `${el[partyFieldName]?.slice(0, 40)}...`,
        ...el,
      };
    }) ?? []
  );
};
